export const publicRoutes = [
  "/organization/login",
  "/organization/sign-up",
  "/employee/login",
  "/reset-password",
  "/products",
  "/switch/",
];
